export default {
    mapSpeedOverrideDeleteSpeedOverride_title:'Eliminar Velocidades Corregidas',
    mapSpeedOverrideDeleteSpeedOverride_title_detail:'¿Esta seguro que desea eliminar las siguientes velocidades corregidas?',
    mapSpeedOverrideDeleteSpeedOverride_warning:'Esta acción no se puede deshacer.',
    mapSpeedOverrideDeleteSpeedOverride_success:'Velocidades corregidas eliminadas',
}